// src/lib/i18n/date/digits.ts
import type { Locale } from "@/lib/i18n";

const PERSIAN = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const ARABIC_INDIC = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

/** Fold Persian (U+06F0-9) and Arabic-Indic (U+0660-9) digits to Latin 0-9. */
export function toLatinDigits(input: string): string {
  return input
    .replace(/[۰-۹]/g, (c) => String(c.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, (c) => String(c.charCodeAt(0) - 0x0660));
}

/**
 * Shape the digits in a formatted string to the locale's digit set.
 * fa → Persian, ar → Arabic-Indic, en → Latin (unchanged). Idempotent.
 * Only digit code points are touched; separators, letters, and markers stay.
 */
export function shapeDigits(input: string, locale: Locale): string {
  const latin = toLatinDigits(input);
  if (locale === "fa")
    return latin.replace(/[0-9]/g, (d) => PERSIAN[Number(d)]);
  if (locale === "ar")
    return latin.replace(/[0-9]/g, (d) => ARABIC_INDIC[Number(d)]);
  return latin;
}
